// import Vue from 'vue'

export function ADDRESSES_DELETING (state, status) {
  state['deleting'] = status
}

export function ADDRESSES_DELETE (state, index) {
  state.all.splice(index, 1)
}

export function ADDRESSES_STORE (state, addresses) {
  state['all'] = addresses
}

export function ADDRESSES_STORE_ONE (state, address) {
  let found = false
  for (const i in state.all) {
    if (state.all[i].id === address.id) {
      found = true
      state.all[i] = address
    }
  }

  if (!found) {
    state.all.push(address)
  }
}

export function ADDRESSES_LOADING (state, status) {
  state['loading'] = status
}

export function ADDRESSES_SAVING (state, status) {
  state['saving'] = status
}

export function ADDRESSES_SELECT (state, address) {
  state['selected'] = address
}
